import BuildingTitle from "../../common/buildingTitle";

export default function ExpensesRecordTitle({titleType, buildingID}) {
    let expenseTypeTitle = titleType === 'edit' ? 'expenseEdit' : 'expenseRecord';

    return (
        <BuildingTitle
            buildingID={buildingID}
            type={expenseTypeTitle}
            sidebarPage
        />
    );
}

